import api from '@tyrio/api-factory';
import { DBFittingBoxSettingsApi } from '@tyrio/dto';
import { ToastHelper, ToastMessageType, ToastType } from '@tyrio/ui-library';
import { useMutation } from 'react-query';

export const useUpdateFittingBox = (refetchFittingBoxSettings: () => void) => {
  const updateFittingBox = useMutation(
    (data: DBFittingBoxSettingsApi['updateOne']['requestBody']) => {
      return api.fetch<DBFittingBoxSettingsApi['updateOne']>(
        'edit_fitting_box_settings',
        {
          ...data,
        }
      );
    },
    {
      onSuccess: () => {
        refetchFittingBoxSettings();
        ToastHelper.showToast(
          'Fitting box',
          ToastType.SUCCESS,
          ToastMessageType.UPDATE
        );
      },
      onError: () => {
        ToastHelper.showToast(
          'Fitting box',
          ToastType.ERROR,
          ToastMessageType.ERROR,
          'An error occurred on edit fitting box!'
        );
      },
    }
  );

  return { updateFittingBox };
};
